import React from "react";
import { motion } from "framer-motion";

const QuoteMethodModal: React.FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => {
  if (!open) return null;

  const handleSMS = () => {
    const phoneNumber = "+639778021411";
    const message = `Can I request a quote for the following details:\nProduct Name:\nQuantity:\nLocation:\nEmail Address:`;
    const smsUrl = `sms:${phoneNumber}?body=${encodeURIComponent(message)}`;
    if (typeof window.gtag_report_conversion === 'function') {
      window.gtag_report_conversion(smsUrl);
    } else {
      window.location.href = smsUrl;
    }
    onClose();
  };

  const handleEmail = () => {
    const emailAddress = "sales@rkandkimport.com";
    const subject = "Quote Request";
    const body = `Can I request a quote for the following details:\nProduct Name:\nQuantity:\nLocation:\nMobile Number:`;
    const mailtoUrl = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    if (typeof window.gtag_report_conversion === 'function') {
      window.gtag_report_conversion(mailtoUrl);
    } else {
      window.location.href = mailtoUrl;
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <motion.div
        className="w-full max-w-md rounded-xl bg-white p-6 shadow-2xl backdrop-blur-md dark:bg-gray-800"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.3 }}
      >
        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Choose Contact Method</h3>
        <p className="text-gray-600 dark:text-gray-400 mb-6">How would you like to request a quote?</p>
        <div className="space-y-4">
          <div className="flex justify-between gap-4">
            <button
              onClick={handleSMS}
              className="flex-1 rounded-lg bg-black px-5 py-2.5 text-center text-sm font-medium text-white shadow-lg transition-all duration-300 ease-in-out hover:bg-gray-800 focus:outline-none focus:ring-4 focus:ring-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600"
            >
              Send via SMS
            </button>
            <button
              onClick={handleEmail}
              className="flex-1 rounded-lg bg-black px-5 py-2.5 text-center text-sm font-medium text-white shadow-lg transition-all duration-300 ease-in-out hover:bg-gray-800 focus:outline-none focus:ring-4 focus:ring-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600"
            >
              Send via Email
            </button>
          </div>
          <button
            onClick={onClose}
            className="w-full rounded-lg bg-gray-200 px-5 py-2.5 text-center text-sm font-medium text-gray-700 shadow-lg transition-all duration-300 ease-in-out hover:bg-gray-300 focus:outline-none focus:ring-4 focus:ring-gray-300 dark:bg-gray-600 dark:text-gray-200 dark:hover:bg-gray-500"
          >
            Cancel
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default QuoteMethodModal;
